import { z } from 'zod'

/**
 * Schema zod compartido para una dirección dentro del portal. Coincide con
 * `CreateControlAddressInput` del gateway (los campos requeridos por el
 * backend) más `isMain` para distinguir la dirección principal.
 *
 * Se usa en wizards de organización y de negocio. Mover aquí la definición
 * evita duplicación y mantiene una única fuente de verdad para la validación
 * de direcciones del lado cliente.
 */
export const addressSchema = z.object({
  street1: z.string().trim().min(1, 'La calle es obligatoria').max(200),
  city: z.string().trim().min(1, 'La ciudad es obligatoria').max(120),
  countryId: z.number().int().positive('Selecciona un país'),
  provinceId: z.number().int().positive('Selecciona una provincia'),
  municipalityId: z.number().int().positive('Selecciona un municipio'),
  isMain: z.boolean(),
})

export type AddressFormValues = z.infer<typeof addressSchema>
